import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faList,
  faLocationDot,
} from "@fortawesome/pro-regular-svg-icons";
import React, { useMemo } from "react";
import DirectoryToolbar from "components/directory/DirectoryToolbar";
import { Filter } from "components/directory/types";
import ProfileFieldFilters from "components/directory/members/ProfileFieldFilters";
import { isEmpty } from "lodash";
import { useParams } from "helpers/tixxt-router";
import { useSelector } from "react-redux";
import { State } from "../../../@types";
import { groupSelector } from "selectors/environment";

type ToolBarArgs = {
  isLoading: boolean;
  filter: Filter;
};

export default function ToolBar({ isLoading, filter }: ToolBarArgs) {
  const { groupSlug } = useParams();
  const context = useSelector((state: State) =>
    groupSlug ? groupSelector(state, groupSlug) : state.network,
  );

  const actions = useMemo(() => {
    const result: React.JSX.Element[] = [];
    if (context.can.invite_internal || context.can.invite_external) {
      result.push(
        <a
          key={"invites"}
          className="btn btn-primary sm:ml-2 flex gap-1 items-center"
          href={`${
            groupSlug ? `/groups/${groupSlug}` : ""
          }/administration/invites/new`}
          title={I18n.t("js.directory.headline_tools.invite_members")}
        >
          <FontAwesomeIcon icon={faCirclePlus} />
          {I18n.t("js.directory.headline_tools.invite_members")}
        </a>,
      );
    }
    if (Preload.current_network.config.maps.enabled) {
      result.push(
        <div key={"maps"} className="btn-group map-btn-group z-0">
          <a className="btn btn-light" href="" title={I18n.t("js.maps.list")}>
            <FontAwesomeIcon icon={faList} />
          </a>
          <a
            className="btn btn-light"
            href="/map"
            title={I18n.t("js.maps.map")}
          >
            <FontAwesomeIcon icon={faLocationDot} />
          </a>
        </div>,
      );
    }
    if (result.length > 0) return <div className="flex gap-2">{result}</div>;
    else return null;
  }, [context]);

  return (
    <DirectoryToolbar
      isLoading={isLoading}
      filter={filter}
      searchField={I18n.t("js.directory.member_tab")}
      actions={actions}
    >
      {!isEmpty(Preload.current_network.directory_filter_profile_fields) && (
        <ProfileFieldFilters currentFilter={filter} />
      )}
    </DirectoryToolbar>
  );
}
